<!--结果页-->
<template>
  <div class="wrong">
    <van-popup round v-model="wrongPop">
      <div class="content">
        <img
          class="wrongbg"
          src="https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/questionlottery/wrongbg.png"
          alt=""
        />
        <div class="result-btn" @click="onClickAdr">获得翻牌机会</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      wrongPop: false,
    };
  },
  props: {},
  computed: {},
  watch: {},

  created() {},
  mounted() {},
  methods: {
    onClickAdr() {
      this.wrongPop = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.wrong {
  .content {
    position: relative;
    .wrongbg {
      display: block;
      width: 600px;
      height: 758px;
      margin: 0 auto;
    }
    .result-btn {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 50px;
      width: 260px;
      height: 80px;
      background: linear-gradient(180deg, #ff6e75 0%, #ff216e 100%);
      border-radius: 40px;
      font-weight: 500;
      font-size: 32px;
      color: #ffffff;
      line-height: 80px;
      text-align: center;
      margin: 90px auto 0;
    }
  }

  ::v-deep{
    .van-popup {
    background-color: transparent !important;
  }
  .van-popup--center{
      top:47%;
    }
  } 
}
</style>
